(function () {
  var KLAVIYO_REVISION = '2026-07-15';
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';

  function getFormData(form) {
    var formData = new FormData(form);
    var searchParams = new URLSearchParams();

    formData.delete('return_to');
    formData.forEach(function (value, key) {
      searchParams.append(key, value);
    });

    return searchParams;
  }

  function submitToShopify(form) {
    return fetch(form.action, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: getFormData(form).toString()
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Shopify signup failed');
      }
    });
  }

  function submitToKlaviyo(email, publicApiKey, listId) {
    if (!publicApiKey) {
      return Promise.resolve();
    }

    var subscription = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'vip_access_signup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        }
      }
    };

    if (listId) {
      subscription.data.relationships = {
        list: {
          data: {
            type: 'list',
            id: listId
          }
        }
      };
    }

    return fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(publicApiKey), {
      method: 'POST',
      keepalive: true,
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(subscription)
    }).then(function (response) {
      if (response.status !== 202) {
        throw new Error('Klaviyo signup failed');
      }
    });
  }

  function showStatus(section, message) {
    var status = section.querySelector('[data-vip-status]');

    if (!status) {
      return;
    }

    status.textContent = message;
    status.hidden = false;
  }

  function setSubmitting(button, isSubmitting) {
    if (!button) {
      return;
    }

    button.disabled = isSubmitting;
    button.classList.toggle('is-loading', isSubmitting);
  }

  function initializeSection(section) {
    if (section.dataset.vipInitialized) {
      return;
    }

    var successMessage = section.querySelector('[data-vip-success]');
    var form = section.querySelector('.vip-access__form');
    var button = section.querySelector('[data-vip-submit]');

    if (successMessage && section.dataset.redirectUrl) {
      window.location.assign(section.dataset.redirectUrl);
      return;
    }

    if (!form) {
      return;
    }

    section.dataset.vipInitialized = 'true';

    form.addEventListener('submit', function (event) {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !form.checkValidity()) {
        return;
      }

      event.preventDefault();
      setSubmitting(button, true);

      submitToKlaviyo(email, section.dataset.klaviyoPublicApiKey, section.dataset.klaviyoListId).catch(function (error) {
        window.console.warn('Klaviyo signup request failed', error);
      });

      submitToShopify(form).then(function () {
        if (section.dataset.redirectUrl) {
          window.location.assign(section.dataset.redirectUrl);
          return;
        }

        showStatus(section, section.dataset.successMessage);
        form.reset();
        setSubmitting(button, false);
      }).catch(function () {
        form.submit();
      });
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-vip-access]').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
